import { PROGRAM_STREAM_TYPE, CUE_PROGRAM_TYPE, SAT_COURSES } from 'constants/program';

import Humanize from 'humanize-plus';

export const getCurrentSelectedProgram = programs => {
  if (!programs || !Array.isArray(programs)) {
    return null;
  }

  const [program] = programs || [];

  return programs.find(prgm => prgm.is_current) || program;
};

export const filterWinsDashboardProgram = program => {
  const { stream: programStream, cue_program_type: programType } = program || {};

  return (
    programType === CUE_PROGRAM_TYPE.CORE &&
    Object.keys(PROGRAM_STREAM_TYPE).includes(programStream)
  );
};

export const getWinsDashboardPrograms = (programs = []) => {
  const shouldReturnEmptyPrograms = (programs?.length || 0) === 0;

  if (shouldReturnEmptyPrograms) {
    return [];
  }

  const filteredPrograms = programs.filter(filterWinsDashboardProgram);

  return filteredPrograms.map(program => {
    const { stream: programStream, name: programName } = program;

    return {
      ...program,
      text: `${Humanize.titleCase(programStream)} : ${Humanize.titleCase(programName)}`,
    };
  });
};

const satCourses = Object.values(SAT_COURSES);

export const isSatCourseSelected = (courseValue, selectedCourse) => {
  if (!selectedCourse) return false;

  const isSatCourse =
    courseValue &&
    courseValue.startsWith('SAT') &&
    satCourses.some(course => course.split('-')[0] === selectedCourse.split('-')[0]);

  return isSatCourse;
};

export const getFilteredPrograms = ({ allPrograms, isMilestoneEnabled, courseValue }) => {
  const isMilestoneEnableResponseProcessing = isMilestoneEnabled === 'PROCESSING';

  const filteredPrograms = allPrograms.filter(program => {
    const { cue_program_type: cueProgramType, stream } = program;
    const isSatCourse = isSatCourseSelected(courseValue, stream);

    if (
      !isMilestoneEnableResponseProcessing &&
      isMilestoneEnabled &&
      (stream === courseValue || isSatCourse) &&
      cueProgramType !== CUE_PROGRAM_TYPE.ELECTIVES
    )
      return true;

    if (
      (!isMilestoneEnabled || isMilestoneEnableResponseProcessing) &&
      cueProgramType !== CUE_PROGRAM_TYPE.ELECTIVES
    )
      return true;
  });

  return filteredPrograms;
};
